import { render, staticRenderFns } from "./EditProfile.vue?vue&type=template&id=62cbc02e&scoped=true&"
import script from "./js/edit.js?vue&type=script&lang=js&"
export * from "./js/edit.js?vue&type=script&lang=js&"
import style0 from "./EditProfile.vue?vue&type=style&index=0&id=62cbc02e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62cbc02e",
  null
  
)

export default component.exports